import * as moment from "moment";
import { isGermany } from "./../services/Helpers";

export default function(value: string) {
  let format = "DD/MM/YYYY";
  if (isGermany()) {
    format = "DD.MM.YYYY";
  }
  if (value) {
    return moment(String(value)).format(format);
  } else {
    return value;
  }
}
